// 四档会员体系（PRD v6）统一口径：wallet.vip_level 0/1/2/3 = 免费 / Pro / Pro Max / 商业版。
// 全控制台（管理员 + 会员展示）一律走此工具，禁止再出现「月费/年费会员」二档旧语义。

export type PlanKey = "free" | "pro" | "pro_max" | "business";

export const PLAN_KEY_BY_LEVEL: Record<number, PlanKey> = {
  0: "free",
  1: "pro",
  2: "pro_max",
  3: "business",
};

// 中文展示名（会员/管理台 UI 用）
export const PLAN_LABEL_CN: Record<number, string> = {
  0: "免费",
  1: "Pro",
  2: "Pro Max",
  3: "商业版",
};

// antd Tag 配色
export const PLAN_COLOR: Record<number, string> = {
  0: "default",
  1: "blue",
  2: "geekblue",
  3: "gold",
};

// 下拉/筛选选项（管理员设置会员等级、商品授予等级、用户筛选）
export const VIP_LEVEL_OPTIONS = [
  { value: 0, label: "免费" },
  { value: 1, label: "Pro" },
  { value: 2, label: "Pro Max" },
  { value: 3, label: "商业版" },
];

// 由 vip_level 得到中文档位名。isVip=false 或 level<=0 视为免费。
export function vipLevelLabel(level?: number, isVip?: boolean): string {
  if (isVip === false) return PLAN_LABEL_CN[0];
  if (level === undefined || level <= 0) return PLAN_LABEL_CN[0];
  return PLAN_LABEL_CN[level] ?? PLAN_LABEL_CN[0];
}

export function vipLevelColor(level?: number, isVip?: boolean): string {
  if (isVip === false || level === undefined || level <= 0) return PLAN_COLOR[0];
  return PLAN_COLOR[level] ?? PLAN_COLOR[0];
}

// 各档可创建的全功能(PostChat)项目上限。免费 0；Pro 1；Pro Max 3；商业版按合同（这里给宽松上限）。
export function postchatProjectLimit(level?: number): number {
  switch (level) {
    case 1:
      return 1;
    case 2:
      return 3;
    case 3:
      return 99;
    default:
      return 0;
  }
}
